const ASC = 'asc';
const DESC = 'desc';

export { ASC, DESC };
